import { TutorialCodes } from '~/constants';
import TutorialModal from '../../TutorialModal';

export default function WorksheetLayoutV2() {
  return (
    <TutorialModal
      title="The worksheet has a new look"
      content={
        <div style={{ fontSize: '0.875rem', lineHeight: 1.5, color: 'var(--color-charcoal)' }}>
          <p>
            We&apos;ve redesigned the project worksheet to fit on a single page. A few things to know:
          </p>
          <ul style={{ paddingLeft: '1.25rem', margin: 0, paddingBottom: '0.75rem', color: 'inherit' }}>
            <li>All sections are now visible at once — scroll or use the table of contents to jump between them.</li>
            <li>Sections are collapsible, so you can focus on whatever you&apos;re working on.</li>
            <li>Your inputs and progress haven&apos;t changed — only the layout.</li>
          </ul>
          <p>
            Questions? Reach out at{' '}
            <a href="mailto:support@conductor.solar">support@conductor.solar</a>.
          </p>
        </div>
      }
      hasCancelButton={false}
      submitButtonText="Got it"
      tutorialCode={TutorialCodes.WORKSHEET_LAYOUT_V2}
    />
  );
}
